import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { RenderDatePicker } from 'components/Common/Inputs';
import DateTimes from 'components/Common/DateTimes';
import moment from 'moment';

const ControllingPersonUnlinkModal = ({
  title,
  message,
  isShown,
  isPerformingAction,
  onConfirm,
  onCancel,
  minDate
}) => {
  const [newEffectiveDate, setNewEffectiveDate] = useState(moment().format('MM-DD-YYYY'));

  const onConfirmEffectiveDate = () => {
    onConfirm(newEffectiveDate);
  };

  return (
    <ModalWrapper
      modalSize="controlling-person-unlink-modal"
      headerClose={ false }
      isOpen={ isShown }
      title={ title }
      btnConfirmTitle="Unlink Record"
      btnConfirmClass={ `btn-danger ${ isPerformingAction ? 'loading' : '' }` }
      btnCancelTitle="Cancel"
      onConfirm={ onConfirmEffectiveDate }
      onCancel={ onCancel }
    >
      <span className="message">
        { message }
      </span>
      <div className="effective-date-datepicker">
        <p><b>Effective Date:</b></p>
        <RenderDatePicker
          input={ { onChange: e => setNewEffectiveDate(e), value: newEffectiveDate && newEffectiveDate.length > 0 ? newEffectiveDate : '' } }
          placeholder="Please select a date"
          dateFormat="MM-dd-yyyy"
          maxDate={ DateTimes.today }
          minDate={ minDate ? moment(minDate).toDate() : null }
          isClearable
        />
      </div>
    </ModalWrapper>
  );
};

ControllingPersonUnlinkModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  isShown: PropTypes.bool,
  isPerformingAction: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  minDate: PropTypes.string
};

ControllingPersonUnlinkModal.defaultProps = {
  title: null,
  message: null,
  isShown: false,
  isPerformingAction: false,
  onConfirm: null,
  onCancel: null,
  minDate: null
};

export default ControllingPersonUnlinkModal;
